import request from "@/utils/request";

// 获取文件前缀
export function getPrefix() {
  return request({
    url: "/commonApi/common/getBaseUploadUrl",
    method: "post"
  })
}

// 获取系统名称
export function getSystemName() {
  return request({
    url: "/commonApi/common/getSysName",
    method: "post"
  })
}


// 从业人员类型下拉选
export function userTypeServiceListApi(data) {
  return request({
    url: "/adminApi/user/userTypeServiceList",
    method: "post",
    data
  })
}
